var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProperties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.50195L21 5.50195",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.50195L14 5.50195",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.502L21 12.502",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.502L6 12.502",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 19.502L21 19.502",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.502L14 19.502",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4142 6.91617C16.6332 7.69722 15.3668 7.69722 14.5858 6.91617C13.8047 6.13512 13.8047 4.86879 14.5858 4.08774C15.3668 3.30669 16.6332 3.30669 17.4142 4.08774C18.1953 4.86879 18.1953 6.13512 17.4142 6.91617Z",
    fill: "#3158F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4142 6.91617C16.6332 7.69722 15.3668 7.69722 14.5858 6.91617C13.8047 6.13512 13.8047 4.86879 14.5858 4.08774C15.3668 3.30669 16.6332 3.30669 17.4142 4.08774C18.1953 4.86879 18.1953 6.13512 17.4142 6.91617",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41421 13.9162C8.63316 14.6972 7.36683 14.6972 6.58578 13.9162C5.80473 13.1351 5.80473 11.8688 6.58578 11.0877C7.36683 10.3067 8.63316 10.3067 9.41421 11.0877C10.1953 11.8688 10.1953 13.1351 9.41421 13.9162Z",
    fill: "#3158F2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41421 13.9162C8.63316 14.6972 7.36683 14.6972 6.58578 13.9162C5.80473 13.1351 5.80473 11.8688 6.58578 11.0877C7.36683 10.3067 8.63316 10.3067 9.41421 11.0877C10.1953 11.8688 10.1953 13.1351 9.41421 13.9162",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4142 20.9162C16.6332 21.6972 15.3668 21.6972 14.5858 20.9162C13.8047 20.1351 13.8047 18.8688 14.5858 18.0877C15.3668 17.3067 16.6332 17.3067 17.4142 18.0877C18.1953 18.8688 18.1953 20.1351 17.4142 20.9162Z",
    fill: "#3158F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4142 20.9162C16.6332 21.6972 15.3668 21.6972 14.5858 20.9162C13.8047 20.1351 13.8047 18.8688 14.5858 18.0877C15.3668 17.3067 16.6332 17.3067 17.4142 18.0877C18.1953 18.8688 18.1953 20.1351 17.4142 20.9162",
    stroke: "#3158F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperties);
export default __webpack_public_path__ + "static/media/properties.dac0c092410cd62f604a4ee27ebf14fb.svg";
export { ForwardRef as ReactComponent };